import React from 'react';
import classnames from 'classnames';

import ToggleItemButton from './toggle-item-button/toggle-item-button';
import fontServiceUtils from 'ub/fonts/font-service/utils-new';

import styles from './font-list-item.scss';

class FontListItem extends React.Component {
  constructor(props) {
    super(props);

    this.getFontListItemStyles = this.getFontListItemStyles.bind(this);
    this.toggleItem = this.toggleItem.bind(this);
    this.iconOut = this.iconOut.bind(this);
    this.iconOver = this.iconOver.bind(this);
    this.toggleButton = this.toggleButton.bind(this);

    this.state = this.getIconStates(props.fontAdded);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getIconStates(nextProps.fontAdded));
  }

  getIconStates(fontAdded) {
    return {
      iconState: fontAdded ? 'active' : 'inactive',
      iconChosen: fontAdded ? 'chosen' : 'available'
    };
  }

  getFontListItemStyles() {
    const fontFamily = fontServiceUtils.getFormattedFontFamily(
      this.props.family
    );
    return {fontFamily};
  }

  toggleItem() {
    if (this.props.fontAdded) {
      this.removeItem();
    } else {
      this.addItem();
    }
  }

  addItem() {
    this.props.modalActionsSubject.onNext({
      type: 'addFont',
      data: {
        family: this.props.family,
        variants: this.props.variants
      }
    });
  }

  removeItem() {
    this.props.modalActionsSubject.onNext({
      type: 'removeFont',
      data: {family: this.props.family}
    });
  }

  isChosen() {
    return this.state.iconChosen === 'chosen';
  }

  iconOver() {
    if (this.isChosen()) {
      this.setState({iconState: 'remove'});
    }
  }

  iconOut() {
    if (this.isChosen()) {
      this.setState({iconState: 'active'});
    }
  }

  toggleButton() {
    return (
      <ToggleItemButton
        toggleItem={this.toggleItem}
        iconState={this.state.iconState}
        iconOver={this.iconOver}
        iconOut={this.iconOut}
      />
    );
  }

  render() {
    const sampleTextLoadClass = classnames(
      styles.sampleText,
      styles[this.props.loaded ? 'loaded' : 'waiting']
    );

    const numberOfStyles = this.props.variants.length;
    const stylesDesc = this.pluralize('style', numberOfStyles);
    const labelText = `${this.props.family} (${numberOfStyles} ${stylesDesc})`;

    return (
      <div className={styles.item}>
        <div className={styles.label}>
          {labelText}
        </div>
        <div
          className={sampleTextLoadClass}
          style={this.getFontListItemStyles()}
        >
          The quick brown fox jumps over the lazy dog.
        </div>
        <div className={classnames(styles.buttonWrap, styles[this.state.iconChosen])}>
          {this.toggleButton()}
        </div>
      </div>
    );
  }

  // Private
  pluralize(word, count) {
    const singular = 1;
    return (count === singular) ? `${word}` : `${word}s`;
  }
}

FontListItem.propTypes = {
  loaded: React.PropTypes.bool,
  fontAdded: React.PropTypes.bool,
  family: React.PropTypes.string,
  variants: React.PropTypes.array,
  modalActionsSubject: React.PropTypes.object
};

export default FontListItem;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-list/font-list-item.jsx